import React from 'react';
import classNames from 'classnames';
import type { MediafilePosterSkeletonProps } from '../MediafilePoster/types';
import styles from './index.module.scss';

export const MediafilePosterSkeleton: React.FC<MediafilePosterSkeletonProps> = ({ className }) => (
  <div
    aria-hidden="true"
    className={classNames(styles.container, className)}
  />
);
